import { VALIDATION_SCOPE } from './validation-scope.constants';


const PROPERTY_CONSTRUCTION_FIELDS = [
    "ConstructionComment",
    "RearOrientationComment",
    "KitchenComment",
    "ConditionComment",
    "HeatingComment",
    "WindowComments",
    "TypeOfRoofComment",
    "InteriorDecors"
];

const PROPERTY_ADMINISTRATOR_FIELDS = [
    "EPCELevel",
    "EnergyPerformance",
    "FloodZoneId",
    "FloodRiskId",
    "FloodRiscAreaId",
    "CadastralIncome",
    "CadastralIncomeI",
    "RiverBankZoneId",
    "UniqueCode",
    "CadastralEntity",
    "CadastralDivision",
    "CadastralSection",
    "CadastralNumber",
    "CadastralRegisteredArea",
    "UrbanInfoCommune",
    "UrbanInfoNumber",
    "HeritageIds",
    "GroundCertificateId",
    "FloodZoneGScore",
    "FloodZonePScore",
    "HasPermitId",
    "HasAllotmentPermitId",
    "HasPreemptiveRightsId",
    "AreaApplicationId"
]



export const TAB_TREE = [
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.GENERAL,
        MAIN_TAB_ID: "tab-general",
        MAIN_TAB_NAME: "general",
        SUB_TAB_ID: null,
        FIELDS: [
            "Reference",
            "StatusId",
            "SubStatusId",
            "SiteId",
            "PurposeId",
            "TypeOfPropertyId",
            "Manager",
            "IsPublishPrice",
            "Price",
            "KeyDesc",
            "FreeAvailableDate",
            "FreeAvailableId",
            "TypeOfRents",
            "NumberOfBedRoom"
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.CONSTRUCTION,
        MAIN_TAB_ID: "tab-GeneralConstruction",
        MAIN_TAB_NAME: "GeneralConstruction",
        SUB_TAB_ID: null,
        FIELDS: PROPERTY_CONSTRUCTION_FIELDS
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.ADMINISTRATION,
        MAIN_TAB_ID: "tab-administration",
        MAIN_TAB_NAME: "administration",
        SUB_TAB_ID: null,
        FIELDS: PROPERTY_ADMINISTRATOR_FIELDS
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.RELATIONS,
        MAIN_TAB_ID: "tab-relation",
        MAIN_TAB_NAME: "relation",
        SUB_TAB_ID: "tab-detail",
        FIELDS: [
            "hasContractCancelled",
            "contractCondition",
            "contractConditionDate",
            "contractCanceledReason",
            "contractDate",
            "mandateStartDate",
            "contractTransferDate",
            "prepaymentPrecentage",
            "contractDeedDate",
            "rentalSignatureDate",
            "salePrice",
            "rentStartDate",
            "CommissionTypeId",
            "SourceContact",
            "Visitinghours",
            "Relations"
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.INVOICE,
        MAIN_TAB_ID: "tab-invoice",
        MAIN_TAB_NAME: "invoice",
        SUB_TAB_ID: null,
        FIELDS: [
            "IntermSalePercent",
            "InvoiceDate",
            "InvoiceNumber",
            "InvoicePaidDate",
            "PaymentComment",
            "PrepaymentComment",
            "RealCommission",
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.MIJNVERHUIS,
        MAIN_TAB_ID: "tab-contact",
        MAIN_TAB_NAME: "contact",
        SUB_TAB_ID: null,
        FIELDS: [
            // Contact details buyer
            "primaryContactId",
            "primaryContactFirstName",
            "primaryContactFamilyName",
            "primaryContactLanguage",
            "primaryContactNationalityId",
            "primaryContactPhoneNumber",
            "primaryContactIdCardNumber",
            "primaryContactCompanyName",
            "primaryContactVAT",
                
            // Current address buyer
            "primaryContactAddress",
            "primaryContactHouseNumber",
            "primaryContactPostCode",
            "primaryContactCityName",
            "primaryContactCountryId",

            // Contact details second buyer
            "secondaryContactId",
            "secondaryContactFirstName",
            "secondaryContactFamilyName",
            "secondaryContactLanguage",
            "secondaryContactNationalityId",
            "secondaryPhoneNumber",
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.MIJNVERHUIS,
        MAIN_TAB_ID: "tab-property",
        MAIN_TAB_NAME: "property",
        SUB_TAB_ID: null,
        FIELDS: [
            "mijnverhuisPropertyCategory",
            "mijnverhuisTransaction",
            "mijnverhuisAddress",
            "mijnverhuisHouseNumber",
            "mijnverhuisPostCode",
            "mijnverhuisCityName",
            "mijnverhuisCountryId",
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROPERTY.MIJNVERHUIS,
        MAIN_TAB_ID: "tab-connect",
        MAIN_TAB_NAME: "connect",
        SUB_TAB_ID: null,
        FIELDS: [
            "ConnectionAvailability",
            "ConnectionAgencyStaffId",
            "ConnectionAgencyStaffUserName",
            "ConnectionAgencyStaffEmail"
        ]
    },
    {
        SCOPE: VALIDATION_SCOPE.COMPANY.GENERAL,
        MAIN_TAB_ID: "tab-general",
        MAIN_TAB_NAME: "general",
        SUB_TAB_ID: null,
        FIELDS: [
            "Name",
            "companyEmail"
           ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PERSON.GENERAL,
        MAIN_TAB_ID: "tab-general",
        MAIN_TAB_NAME: "general",
        SUB_TAB_ID: null,
        FIELDS: [
            "name",
            "firstName",
            "middleName",
            "reference",
            "personMultsStringArray",
            "emailValidation",
            "phoneValidation",
            "originContactId"
           ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PERSON.DETAIL,
        MAIN_TAB_ID: "tab-detail",
        MAIN_TAB_NAME: "detail",
        SUB_TAB_ID: null,
        FIELDS: [
            "bicA",
            "bicB",
            "bankA",
            "bankB",
            "biv",
            "rc",
            "vat",
            "national",
            "profession",
            "idCard",
            "partner",
            "birthPlace",
            "chipNumber",
            "partner"
           ]
    },
    {
        SCOPE: VALIDATION_SCOPE.PROJECT.CONSTRUCTION,
        MAIN_TAB_ID: "tab-construction",
        MAIN_TAB_NAME: "construction",
        SUB_TAB_ID: null,
        FIELDS: PROPERTY_CONSTRUCTION_FIELDS
    },
    {
        SCOPE: VALIDATION_SCOPE.PROJECT.ADMINISTRATION,
        MAIN_TAB_ID: "tab-administration",
        MAIN_TAB_NAME: "administration",
        SUB_TAB_ID: null,
        FIELDS: PROPERTY_ADMINISTRATOR_FIELDS
    },
    {
        SCOPE: VALIDATION_SCOPE.USER.UserListing,
        MAIN_TAB_ID: "user-listing",
        MAIN_TAB_NAME: "listing",
        SUB_TAB_ID: null,
        FIELDS: [
            "name"
           ]
        },
        {
            SCOPE: VALIDATION_SCOPE.PROPERTY.KORFINE,
            MAIN_TAB_ID: "tab-agreement",
            MAIN_TAB_NAME: "agreement",
            SUB_TAB_ID: null,
            FIELDS: [
                "TypeOfRentalAgreement",
                "BasicRentPrice",
                "DateOfEntry",
                "DateOfContract",
                "EstateCategory",
                "EstateSort",
                "EstateHouseNumber",
                "EstateStreet",
                "EstateZipcode",
                "EstateCity",
                "EstateCountry"
            ]
        },
        {
            SCOPE: VALIDATION_SCOPE.PROPERTY.KORFINE,
            MAIN_TAB_ID: "tab-owner",
            MAIN_TAB_NAME: "owner",
            SUB_TAB_ID: null,
            FIELDS: [
                "Category",
                "Reference",
                "Name",
                "Email",
                "Street",
                "HouseNumber",
                "Zipcode",
                "City",
                "Country",
                "Nationality",
                "PCategory",
                "PReference",
                "PName",
                "PEmail",
                "PStreet",
                "PHouseNumber",
                "PZipcode",
                "PCity",
                "PCountry",
                "PNationality"
            ]
        },
        {
            SCOPE: VALIDATION_SCOPE.PROPERTY.KORFINE,
            MAIN_TAB_ID: "tab-tenant",
            MAIN_TAB_NAME: "tenant",
            SUB_TAB_ID: null,
            FIELDS: [
                "TCategory",
                "TReference",
                "TName",
                "TEmail",
                "TStreet",
                "THouseNumber",
                "TZipcode",
                "TCity",
                "TCountry",
                "TNationality",
                "TPCategory",
                "TPReference",
                "TPName",
                "TPEmail",
                "TPStreet",
                "TPHouseNumber",
                "TPZipcode",
                "TPCity",
                "TPCountry",
                "TPNationality"
            ]
    
    }
];